import { statusConfig } from 'components/atoms/JobStatus';
import { visibilityConfig } from 'components/atoms/JobVisibility';
import { displayCompensationPeriod } from 'helpers/compensation';
import strings from 'strings';
import moment from 'moment';
import pluralize from 'pluralize';
import { mapSeniorityType } from 'services/contacts/seniorityTypes';
import { getAuthor, getExpirationDate } from './jobHelpers';

export const getJobHeader = (jobCount) => `${jobCount?.toLocaleString()} ${pluralize('job', jobCount ?? 0)}`;

export const getJobsColumns = (columnsToHide, { totalJobs = 0, isLoading = false } = {}) =>
  [
    {
      Header: isLoading ? 'Loading...' : getJobHeader(totalJobs),
      accessor: 'title',
      width: '320px',
      disableSortBy: true,
      lockPosition: 'left',
      pinned: 'left',
      hideOnTableColumn: true,
      suppressMovable: true,
      valueFormatter: ({ data: { original } }) => original.title,
    },
    {
      Header: 'People Finder',
      accessor: 'peopleFinder',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => (original?.findemProjectId ? 'Open project' : 'Find candidates'),
    },
    {
      Header: 'Company',
      accessor: 'company',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({
        data: {
          original: { organization },
        },
      }) => organization?.name,
    },
    {
      Header: 'Job function',
      accessor: 'jobFunction',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => original.jobFunctions.map((item) => item.name).join(', '),
    },
    {
      Header: 'Seniority',
      accessor: 'seniority',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => mapSeniorityType(original.seniority),
    },
    {
      Header: 'Location',
      accessor: 'location',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({
        data: {
          original: { locations },
        },
      }) => (locations?.length ? locations.join(', ') : '-'),
    },
    {
      Header: 'Compensation',
      accessor: 'compensation',
      width: '200px',
      disableSortBy: true,
      valueFormatter: ({
        data: {
          original: {
            compensationCurrency,
            compensationAmountMinCents,
            compensationAmountMaxCents,
            compensationPeriod,
            compensationOffersEquity,
          },
        },
      }) =>
        displayCompensationPeriod({
          currency: compensationCurrency,
          amountMinCents: compensationAmountMinCents,
          amountMaxCents: compensationAmountMaxCents,
          offersEquity: compensationOffersEquity,
          period: compensationPeriod,
        }) || '-',
    },
    {
      Header: 'Source',
      accessor: 'source',
      width: '104px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => strings.jobs.job_sources_for_admin_portal[original.source],
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: '96px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => statusConfig[original.status]?.status ?? '',
    },
    {
      Header: 'Visibility',
      accessor: 'visibility',
      width: '120px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => visibilityConfig[original.visibility]?.status ?? 'Visible',
    },
    {
      Header: 'Featured',
      accessor: 'featured',
      width: '120px',
      disableSortBy: true,
      valueFormatter: ({ data: { original } }) => (original.featured === 'featured' ? 'Featured' : '-'),
    },
    {
      Header: 'Created by',
      accessor: 'createdBy',
      disableSortBy: true,
      width: '160px',
      valueFormatter: ({ data: { original } }) => getAuthor(original),
    },
    {
      Header: 'Created on',
      accessor: 'createdAt',
      width: '160px',
      valueFormatter: ({ data: { original } }) => moment(original.createdAt).format('D MMM YYYY'),
    },
    {
      Header: 'Applicants',
      accessor: 'applicants',
      disableSortBy: true,
      width: '96px',
      valueFormatter: ({ data: { original } }) => original.jobApplicantsCount ?? '-',
    },
    {
      Header: 'Expiring',
      accessor: 'expirationDate',
      width: '112px',
      valueFormatter: ({ data: { original } }) => getExpirationDate(original),
    },
  ].filter((column) => !columnsToHide.has(column.accessor));
